// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import __setDefaultSdkOptions from "../sdk-helpers/__setDefaultSdkOptions";

import createAccountDelete from "./account/postAccountDelete";
import createEmailChangeConfirm from "./email/postEmailChangeConfirm";
import createEmailChangeRequest from "./email/postEmailChangeRequest";
import createEmailRemove from "./email/postEmailRemove";
import createIdentityGet from "./identity/postIdentityGet";
import createIdentityMethodsGet from "./identity/postIdentityMethodsGet";
import createIdentityUnlink from "./identity/postIdentityUnlink";
import createOauthAppleLink from "./oauth/postOauthAppleLink";
import createOauthGoogleLink from "./oauth/postOauthGoogleLink";
import createSessionList from "./session/postSessionList";
import createSessionRevoke from "./session/postSessionRevoke";
import createSessionRevokeAllOthers from "./session/postSessionRevokeAllOthers";
import createSessionRevokeOne from "./session/postSessionRevokeOne";
import createSupportIdentityGet from "./support/postSupportIdentityGet";

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

// Every method is built from RESOLVED options, never the raw argument.
// `sdk()` with no arguments has to work. That is the shape every generated
// hook uses through useCallSdk(), and passing the raw `undefined` through
// gave those methods no apiHost and no "/v1/<zone>" prefix, so they POSTed to
// a bare relative "/resource/action".
export default function sdk(options?: SdkOptions) {
  const resolvedOptions = __setDefaultSdkOptions(options);
  return {
    postAccountDelete: createAccountDelete(resolvedOptions),
    postEmailChangeConfirm: createEmailChangeConfirm(resolvedOptions),
    postEmailChangeRequest: createEmailChangeRequest(resolvedOptions),
    postEmailRemove: createEmailRemove(resolvedOptions),
    postIdentityGet: createIdentityGet(resolvedOptions),
    postIdentityMethodsGet: createIdentityMethodsGet(resolvedOptions),
    postIdentityUnlink: createIdentityUnlink(resolvedOptions),
    postOauthAppleLink: createOauthAppleLink(resolvedOptions),
    postOauthGoogleLink: createOauthGoogleLink(resolvedOptions),
    postSessionList: createSessionList(resolvedOptions),
    postSessionRevoke: createSessionRevoke(resolvedOptions),
    postSessionRevokeAllOthers: createSessionRevokeAllOthers(resolvedOptions),
    postSessionRevokeOne: createSessionRevokeOne(resolvedOptions),
    postSupportIdentityGet: createSupportIdentityGet(resolvedOptions),
  };
}
